import { microAppSwitch } from './utils'
import { navigate } from './utils'

export const adapterAfterLoginNavigate = microAppSwitch(() => {
    if (window.isPrivate) {
        navigate('/privateLogin');
    } else {
        navigate('/login')
    }
})